import { render, staticRenderFns } from "./MobileRegistration.vue?vue&type=template&id=0d857c3c&"
import script from "./MobileRegistration.vue?vue&type=script&lang=js&"
export * from "./MobileRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports